import { DiagnosticCodeType } from "@/Common/Models/Patient/Enum/DiagnosticCodeType";

class DiagnosisHelper {
    public static getSourceNameFromCode(type: DiagnosticCodeType): string {
        switch (type) {
            case DiagnosticCodeType.InternationalClassificationOfDiseases_V9:
            case DiagnosticCodeType.InternationalClassificationOfDiseases_V9_MexicoOnly:
                return "ICD9";

            case DiagnosticCodeType.InternationalClassificationOfDiseases_V9_BritishColumbiaOnly:
                return "ICD9 MSP";

            case DiagnosticCodeType.InternationalClassificationOfDiseases_V10:
                return "ICD10";

            case DiagnosticCodeType.InternationalClassificationOfDiseases_V10_MexicoOnly:
                return "ICD10_MX";

            case DiagnosticCodeType.InternationalClassificationOfPrimaryCare:
                return "ICPC";

            case DiagnosticCodeType.InternationalClassificationOfDiseases_V9_OntarioMinistryOfHealth:
                return "MOH ICD9";

            default:
                return "";
        }
    }
}

export { DiagnosisHelper };
